module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Better Mood","short_name":"BetterMood","start_url":"/","background_color":"#ffffff","theme_color":"#1a73e8","display":"standalone","icon":"src/images/favicon/light_mode.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"1cdb02a5faac061efed1eb20d4787671"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
